<template>
  <div class="mt-5 flex md:hidden">
    <div class="space-y-2 bg-gold-20 p-4">
      <div
        v-for="(benefit, index) in benefits"
        :key="index"
        class="flex items-start"
      >
        <Icon :icon="benefit.icon" class="mr-2 inline-block size-4 shrink-0" />
        <div class="text-[14px]">
          {{ $t(benefit.key) }}
          <NuxtLink
            v-if="benefit.hasLink"
            :to="newsletterSubscribePath"
            class="ml-1 inline-flex items-center gap-2 leading-none underline"
          >
            <Icon icon="arrow-right-small" size="3" />
            {{ $t('benefits.newsletter_sign_up_now') }}
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Icon from '#layers/base/components/ui/icons/Icon.vue'
import useCountryCheck from '#layers/base/composables/useCountryCheck'
import useRouteHelpers from '#layers/base/composables/useRouteHelpers'

const { toLocalePath } = useRouteHelpers()
const newsletterSubscribePath = toLocalePath('/c/service/newsletter/subscribe')

const currentShop = useCurrentShop()
const { isInList: isSwitzerland } = useCountryCheck(['fr-ch', 'ch'])
const showBenefitFreeReturns = computed(() => {
  const { shopId } = currentShop.value ?? {}
  return ![10003, 10004].includes(shopId) && !isSwitzerland.value
})

const benefits = computed(() => {
  const list = [
    {
      key: 'benefits.secure_purchase_on_invoice',
      icon: 'purchase-on-invoice-mobile',
      hasLink: false,
    },
  ]
  if (showBenefitFreeReturns.value) {
    list.push({
      key: 'benefits.free_returns_14_days',
      icon: 'free-returns-mobile',
      hasLink: false,
    })
  }
  list.push({
    key: 'benefits.welcome_discount_newsletter',
    icon: 'discount-bag-mobile',
    hasLink: true,
  })
  return list
})
</script>
